import { mortgageAPI } from "../../services/MortgageAPI";
import { MortageDetailsModel } from "../../model/MortageDetailsModel";

class MortageDetailsService {
	public saveMortgageCompany = async (mortgageData: MortageDetailsModel): Promise<string> => {
		const apiResponse: string = await mortgageAPI.createMortgageCompany(mortgageData);
		return apiResponse;
	}

	public updateMortgageCompany = async (mortgageData: MortageDetailsModel): Promise<string> => {
		const apiResponse: string = await mortgageAPI.updateMortgageCompany(mortgageData);
		return apiResponse;
	}
}

export const mortageDetailsService = new MortageDetailsService();